import Vue from 'vue'
import Router from 'vue-router'
import Project from '@/components/Project'
import Lab from '@/components/Lab'
import projects from '@/json/projects'

Vue.use(Router)

const router =  new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Project
    },
    {
      path: '/lab',
      name: 'Lab',
      component: Lab
    },
    {
      path: '/:project',
      name: 'Project',
      component: Project
    }
  ]
})

router.beforeEach((to, from, next) => {
  if(to.name === 'Lab'){
    next()
  }
  else if(to.name === 'Home'){
    next('/kenrig')
  }
  else{
    if(projects.findIndex(p => p.slug === to.params.project) > -1){
      next()
    }
    else{
      next('/kenrig')
    }
  }
})

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js